import React from 'react';
import { FormattedMessage } from 'react-intl';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown';
import { Box } from '@osmosis/react-ui/components/Box';
import { Button } from '@osmosis/react-ui/components/Button';
import { Icon } from '@osmosis/react-ui/components/Icon';

/**
 * Explanation dropdown for multiple-choice options.
 */
export const ExplanationDropDown = ({
  isOpen,
  setExplanationVisible,
}: {
  isOpen: boolean;
  setExplanationVisible: (val: boolean) => void;
}) => {
  return (
    <Box>
      <Button
        endIcon={<Icon icon={faAngleDown} />}
        data-testid="show-explanation-btn"
        bg="gray10"
        color="text"
        size="s"
        onClick={() => setExplanationVisible(!isOpen)}
      >
        {!isOpen ? (
          <FormattedMessage
            id="quiz.answer-choice.show-explanation"
            defaultMessage="Show explanation"
          />
        ) : (
          <FormattedMessage
            id="quiz.answer-choice.hide-explanation"
            defaultMessage="Hide explanation"
          />
        )}
      </Button>
    </Box>
  );
};
